import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import dayjs from "dayjs"
import React from "react"
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import DoneIcon from '@mui/icons-material/Done'
import { Message } from "common/types"
import { MessageStatusEnum } from "common/enums"
import { defaultColorPallete } from "utils"

type MessageMoreInfoProps = {
    message: Message
}

export function MessageMoreInfo({ message }: MessageMoreInfoProps) {
    const keyIdentifier = message.fromMe ? "messageSender" : "messageRecipient"
    return (

        <Box key={`OpenedChat-${message.id}-${keyIdentifier}MessageDetails`} width='100%' display='flex' gap={0.4}>
            {message?.receivedAt ? (
                <React.Fragment key={`OpenedChat-${message.id}-${keyIdentifier}MessageAditionalInfo`}>
                    <Typography variant='caption' key={`OpenedChat-${message.id}-${keyIdentifier}MessageTime`} fontSize='0.6rem' width='100%' component='p' textAlign='right' alignContent='center'>
                        {dayjs(message.receivedAt).format('HH:mm')}
                    </Typography>
                    {message.fromMe && (
                        <>
                            {message.status === MessageStatusEnum.SERVER_ACK && (<DoneIcon
                                key={`OpenedChat-${message.id}-${keyIdentifier}${MessageStatusEnum.SERVER_ACK}DeldInfo`}
                                sx={{ fontSize: '0.9rem' }}
                                color={'disabled'}
                            />)}
                            {(message.status !== MessageStatusEnum.SERVER_ACK && (<DoneAllIcon
                                key={`OpenedChat-${message.id}-${keyIdentifier}${MessageStatusEnum.DELIVERY_ACK}Info`}
                                sx={{ fontSize: '0.9rem' }}
                                color={message.status === MessageStatusEnum.READ || message.status === MessageStatusEnum.PLAYED ? 'primary' : 'disabled'}
                            />))}
                        </>
                    )}
                </React.Fragment>
            ) : (
                <Box key={`OpenedChat-${message.id}-${keyIdentifier}SendingInfo`} textAlign='right' flex={1}>
                    <AccessTimeIcon sx={{ fontSize: '0.6rem' }} />
                </Box>
            )}
        </Box>
    )
}

export const formatMessage = (text: string) => {
    if (!text) return null

    const urlRegex = /(https?:\/\/[^\s]+)/g

    return text.split(/(\*.*?\*|_.*?_|~.*?~|```.*?```|https?:\/\/[^\s]+|\n)/g).map((part: string, index: number) => {
        if (part === "\n") {
            return <br key={index} />
        } else if (urlRegex.test(part)) {
            return (
                <a
                    key={index}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: defaultColorPallete.primary.dark, wordBreak: 'break-word' }}
                >
                    {part}
                </a>
            )
        } else if (part.startsWith('*') && part.endsWith('*')) {
            return <b key={index}>{part.slice(1, -1)}</b>
        } else if (part.startsWith('_') && part.endsWith('_')) {
            return <i key={index}>{part.slice(1, -1)}</i>
        } else if (part.startsWith('~') && part.endsWith('~')) {
            return <s key={index}>{part.slice(1, -1)}</s>
        } else if (part.startsWith('```') && part.endsWith('```')) {
            return (
                <code key={index} style={{ backgroundColor: '#f5f5f5', padding: '2px 4px', borderRadius: '4px' }}>
                    {part.slice(3, -3)}
                </code>
            )
        }
        return part
    })
}
